export const COMMIT = 'd1a057d';
